module.exports = __webpack_public_path__ + "img/fz.8c4135e5.png";